export const reduceUsers = (users) => {
	return users
		? users.reduce((acc, current) => {
				const x = acc.find((item) => item.id === current.id);
				if (!x) {
					return acc.concat([current]);
				} else {
					return acc;
				}
		  }, [])
		: [];
};

export const reduceService = (users) => {
	return users
		? users.reduce((acc, current) => {
				const x = acc.find((item) => item.id === current.id);
				if (!x) {
					return acc.concat([current]);
				} else {
					return acc;
				}
		  }, [])
		: [];
};

export const sortArray = (array) => {
	return array.sort(function (a, b) {
		if (a < b) return -1;
		else if (a > b) return 1;
		return 0;
	});
};
